import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import actions from './actions';

export const initialState = {
  afsLicensees: [],
  isFetching: false,
  error: null
};

const reducer = handleActions({
  [actions.dataGov.api.licensees.get.request]: (state, action) => {
    return Object.assign({}, state, {
      afsLicensees: [],
      isFetching: true
    });
  },
  [actions.dataGov.api.licensees.get.success]: (state, action) => {
    return Object.assign({}, state, {
      isFetching: false,
      afsLicensees: action.payload.afsLicensees,
      error: null
    });
  },
  [actions.dataGov.api.licensees.get.failed]: (state, action) => {
    return Object.assign({}, state, {
      isFetching: false,
      error: action.payload.error
    });
  },
  [LOCATION_CHANGE]: (state, action) => {
    return Object.assign({}, state, initialState);
  }
}, {
    ...initialState
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/data-gov/reducers.js